import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

//Componentes Atentus
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Feedback from '../../layouts/Dashboard/components/Topbar/components/Feedback';
import Link from '@mui/material/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { styled } from '@mui/material/styles';
import CloseIcon from '@material-ui/icons/Close';
import RectangleRoundedIcon from '@mui/icons-material/RectangleRounded';

// import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { NavLink } from 'react-router-dom';
import { getQueryParams } from '../../utils/fns/get-query-params';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#E8E8E8',
  ...theme.typography.body2,
  padding: theme.spacing(4),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


const Item2 = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#FFF',
    ...theme.typography.body2,
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));



// Component styles
const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#fff',
        height: '100%',
    },
    item: {
        height: '100%'
    }
});

const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );

  const renderCard = (t) => (
    <React.Fragment>
      <CardContent>
        <Typography color="text.secondary" gutterBottom>
          <p style={{ fontSize:14,color:'rgba(0,0,0,0.6)', lineHeight: 1.5}}> {t('support.card.section')} </p>
        </Typography>
        <Typography  component="div">
          <p style={{ fontSize:34, lineHeight: 1.5}}>{t('support.card.welcomePrefix')}{sessionStorage.getItem('user_name')}</p>
        </Typography>
        <Typography  color="text.secondary">
          <p style={{ fontSize:16 ,color:'rgba(0,0,0,0.6)',lineHeight: 1.5}}>{t('support.card.howCanWeHelp')}</p>
        </Typography>
          <Box>
            <Grid container spacing={6} rowSpacing={3} columnSpacing={{ xs: 3, sm: 3, md: 3 }}>
              <Grid item xs={12}>
                  <Box padding={2}>
                  <Typography fontWeight='bold'>
                    {t('support.card.faqTitle')}
                  </Typography>
                </Box>
                <Box padding={2} style={{height: 400, overflowY: 'auto'}}>
                  {/* PREGUNTAS FRECUENTES */}
                  <Accordion style={{textAlign:'Left',}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q1.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q1.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left',}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q2.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q2.part1')}
                      <br/>
                      {t('support.faq.q2.action')} <b>{t('support.faq.q2.bold.option')}</b> {t('support.faq.q2.afterBold1')} <b>{t('support.faq.q2.bold.profile')}</b> {t('support.faq.q2.afterBold2')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left',}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q3.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q3.part1')} <b>{t('support.faq.q3.bold.optUsuarios')}</b> {t('support.faq.q3.part2')} <b>{t('support.faq.q3.bold.miPerfil')}</b> {t('support.faq.q3.part3')} <b>{t('support.faq.q3.bold.cambiarClave')}</b> {t('support.faq.q3.part4')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left',}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel20a-content"
                      id="panel20a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q4.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q4.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left',}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel23a-content"
                      id="panel23a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q5.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q5.intro')}
                      <br/>
                      <>&nbsp;</> <>&nbsp;</><FiberManualRecordIcon style={{ verticalAlign: 'middle',display: 'inline-flex'}} fontSize="small" />
                        {t('support.faq.q5.opt1.prefix')} <Link target="_blank" href="https://atentus.com/">{t('support.faq.q5.opt1.link')}</Link> {t('support.faq.q5.opt1.suffix')}
                      <br/>
                      <>&nbsp;</> <>&nbsp;</><FiberManualRecordIcon style={{ verticalAlign: 'middle',display: 'inline-flex'}} fontSize="small" />
                        {t('support.faq.q5.opt2.prefix')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left',}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q6.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q6.part1')} <b>{t('support.faq.q6.bold.url')}</b> {t('support.faq.q6.part2')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q7.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q7.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q8.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q8.part1')}
                      <br/>
                      {t('support.faq.q8.part2')} <b>{t('support.faq.q8.bold.phone')}</b> {t('support.faq.q8.part3')}

                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q9.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q9.part1')} <b>{t('support.faq.q9.bold.url')}</b>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em',textAlign:'Left'}} >
                        {t('support.faq.q10.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q10.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q11.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q11.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel21a-content"
                      id="panel21a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q12.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q12.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q13.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q13.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion style={{textAlign:'Left'}}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel22a-content"
                      id="panel22a-header"
                      style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                    >
                      <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                        {t('support.faq.q14.title')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography style={{textAlign:'Left'}}>
                      {t('support.faq.q14.content')}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box padding={2} paddingTop={0}>
                          <Typography fontWeight='bold'>
                    {t('support.definitions.title')}
                  </Typography>
                </Box>
                <Box padding={2} style={{height: 400, overflowY: 'auto'}}>
                  <Accordion style={{textAlign:'Left'}}>
                          <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def1.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign: 'left'}}>
                          {t('support.definitions.def1.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def2.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                          {t('support.definitions.def2.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel16a-content"
                          id="panel16a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def3.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                          {t('support.definitions.def3.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel9a-content"
                          id="panel9a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def4.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                          {t('support.definitions.def4.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel9a-content"
                          id="panel9a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def5.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def5.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel17a-content"
                          id="panel17a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def6.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def6.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel3a-content"
                          id="panel3a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def7.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                          <b>{t('support.definitions.def7.item1.label')}</b> {t('support.definitions.def7.item1.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex'}} fontSize="large" color="success"/>
                            {t('support.definitions.def7.item1.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def7.item2.label')}</b> {t('support.definitions.def7.item2.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex', color :"#F4D03F"}} fontSize="large" />.
                            {t('support.definitions.def7.item2.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def7.item3.label')}</b> {t('support.definitions.def7.item3.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex',color :"#FF0000"}} fontSize="large" />.
                          {t('support.definitions.def7.item3.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def7.item4.label')}</b> {t('support.definitions.def7.item4.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex',color :"#F0EDED"}}  fontSize="large" /> .
                          {t('support.definitions.def7.item4.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def7.item5.label')}</b> {t('support.definitions.def7.item5.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex',color :"#F0EDED"}}  fontSize="large" />
                            {t('support.definitions.def7.item5.detail')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel4a-content"
                          id="panel4a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def8.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                          <b>{t('support.definitions.def8.item1.label')}</b> {t('support.definitions.def8.item1.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex'}} fontSize="large" color="success"/>
                          {t('support.definitions.def8.item1.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def8.item2.label')}</b> {t('support.definitions.def8.item2.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex', color :"#F4D03F"}} fontSize="large" />
                          {t('support.definitions.def8.item2.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def8.item3.label')}</b> {t('support.definitions.def8.item3.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex',color :"#FF0000"}} fontSize="large" />
                          {t('support.definitions.def8.item3.detail')}
                          <br />
                          <br />
                          <b>{t('support.definitions.def8.item4.label')}</b> {t('support.definitions.def8.item4.after')}
                          <RectangleRoundedIcon style={{ verticalAlign: 'middle',display: 'inline-flex',color :"#F0EDED"}}  fontSize="large" />
                          {t('support.definitions.def8.item4.detail')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel5a-content"
                          id="panel5a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def9.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def9.part1')}
                            <br />
                            <b>{t('support.definitions.def9.bold.code')}</b> {t('support.definitions.def9.codeDetail')}
                            <br />
                            <b>{t('support.definitions.def9.bold.responseTime')}</b> {t('support.definitions.def9.responseDetail')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel6a-content"
                          id="panel6a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def10.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def10.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel19a-content"
                          id="panel19a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def11.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def11.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel7a-content"
                          id="panel7a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def12.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def12.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel8a-content"
                          id="panel8a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def13.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            <b>{t('support.definitions.def13.bold.slaOk')}</b> {t('support.definitions.def13.slaOkDetail')}
                            <br />
                            <b>{t('support.definitions.def13.bold.slaError')}</b> {t('support.definitions.def13.slaErrorDetail')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel8a-content"
                          id="panel8a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def14.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def14.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel10a-content"
                          id="panel10a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def15.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def15.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel11a-content"
                          id="panel11a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def16.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def16.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel12a-content"
                          id="panel12a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def17.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def17.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel13a-content"
                          id="panel13a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def18.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def18.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel14a-content"
                          id="panel14a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def19.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def19.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel15a-content"
                          id="panel15a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def20.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def20.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel18a-content"
                          id="panel18a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def21.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def21.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion style={{textAlign:'Left'}}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel8a-content"
                          id="panel8a-header"
                          style={{ backgroundColor :'#E8E8E8',padding:'0px 16px',width:'100%'}}
                        >
                          <Typography style={{fontWeight:450,fontSize:'16px',lineHeight:1.5,letterSpacing:'0.00938em'}} >
                            {t('support.definitions.def22.title')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography style={{textAlign:'Left'}}>
                            {t('support.definitions.def22.content')}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                </Box>
              </Grid>
            </Grid>
        </Box>
      </CardContent>
    </React.Fragment>
  );


class Support extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {}
        }
    }

    handleShowFeedback=(e)=>{
      this.setState({
          FeedbackEl: e.currentTarget
      });
    }

    handleCloseFeedback = () => {
        this.setState({
            FeedbackEl: null,
        });
    };

    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }

    render() {
        const { classes, t } = this.props;
        const { objectivesList,FeedbackEl} = this.state
        const showFeedback = Boolean(FeedbackEl);
        return (
            <div>
              {/* <UserNotification /> */}
              <DashboardLayout title={t('support.pageTitle')} callbackFromParent={this.myCallback} isFirstTime={true}>
                <div className={classes.root}>
                  <Grid
                      container
                      spacing={2}
                  >
                    <Grid
                        item
                        sm={8}
                        xl={8}
                        xs={12}
                    >
                      <Box>
                        <Card variant="outlined">{renderCard(t)}</Card>
                      </Box>
                    </Grid>
                    <Grid
                        item
                        sm={4}
                        xl={4}
                        xs={12}
                    >
                      <Card variant="outlined">
                        <React.Fragment>
                          <CardContent>
                            <Typography variant="h5" component="div" style={{marginBottom: '10px'}}>
                              <p style={{ fontSize:24, lineHeight: 1.5}}>{t('support.card.assistance.title')}</p>
                            </Typography>
                            <Typography color="text.secondary" style={{marginBottom: '10px'}}>
                              <p style={{ fontSize:16 ,color:'rgba(0,0,0,0.6)'}}>
                              {t('support.card.assistance.description')}</p>
                            </Typography>
                            <Grid item xs={12}>
                              <Box padding={2} backgroundColor= '#E8E8E8' borderRadius={2}>
                                <Typography sx={{ fontSize: 14 }} color="text.secondary">
                                  <Typography style={{marginBottom: '10px'}} color="text.secondary" fontWeight='bold'>
                                    {t('support.card.contact.title')}
                                  </Typography>
                                  <Typography style={{marginBottom: '10px'}} color="text.secondary">{t('support.card.contact.emailLabel')}</Typography>
                                  <Typography color="text.secondary" style={{fontWeight: '500', marginBottom: '10px'}}>{t('support.card.contact.email')}</Typography>
                                  <Typography style={{marginBottom: '10px'}} color="text.secondary">{t('support.card.contact.phoneLabel')}</Typography>
                                  <Typography color="text.secondary" style={{fontWeight: '500'}}>{t('support.card.contact.phone')}</Typography>
                                </Typography>
                              </Box>
                            </Grid>
                          </CardContent>
                          <CardContent>
                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom></Typography>
                            <Typography variant="h5" component="div">
                              <p style={{ fontSize:16, lineHeight: 1.5}}>{t('support.card.feedback.title')}</p>
                            </Typography>
                            <Typography  color="text.secondary">
                              <p style={{ fontSize:16 ,color:'rgba(0,0,0,0.6)',lineHeight: 1.5}}>{t('support.card.feedback.description')}</p>
                            </Typography>
                            <Grid item xs={12}>
                              <Item style={{ backgroundColor :'#E8E8E8', padding: '0px', cursor: 'pointer'}}>
                                <Grid item xs={12}>
                                  <IconButton
                                    onClick={this.handleShowFeedback}
                                    style={{borderRadius: '5px', backgroundColor: '#e8e8e8', width: '100%'}}>
                                    <Typography>{t('support.card.feedback.button')}</Typography>
                                  </IconButton>
                                </Grid>
                              </Item>
                            </Grid>
                          </CardContent>
                          <CardContent>
                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom></Typography>
                            <Typography variant="h5" component="div">
                              <p style={{ fontSize:18, lineHeight: 1.5}}>{t('support.card.simbologia.title')}</p>
                            </Typography>
                            <Typography  color="text.secondary">
                              <p style={{ fontSize:16 ,color:'rgba(0,0,0,0.6)',lineHeight: 1.5}}>{t('support.card.simbologia.description')}</p>
                            </Typography>
                            <Grid item xs={12}>
                              <Item style={{ backgroundColor :'#E8E8E8', padding: '0px'}}>
                                <Grid item xs={12}>
                                  <NavLink to={{pathname: '/simbologia', search: getQueryParams()}}>
                                  <IconButton
                                    style={{borderRadius: '5px', backgroundColor: '#e8e8e8', width: '100%'}}>
                                    <Typography>{t('support.card.simbologia.button')}</Typography>
                                  </IconButton>
                                  </NavLink>
                                </Grid>
                              </Item>
                            </Grid>
                          </CardContent>
                        </React.Fragment>
                      </Card>
                      <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={showFeedback}
                        onClose={this.handleCloseFeedback}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                      >
                        <Fade in={showFeedback}>
                          <Feedback handleCloseFeedback={this.handleCloseFeedback}/>
                        </Fade>
                      </Modal>
                    </Grid>
                  </Grid>
                </div>
              </DashboardLayout>
            </div>
        );
    }
}

Support.propTypes = {
    classes: PropTypes.object.isRequired
};

Support.propTypes = Object.assign({}, Support.propTypes, {
  t: PropTypes.func
});

export default withTranslation()(withStyles(styles)(Support));